import { HttpHeaders } from "@angular/common/http";
import { Component, effect, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { DataTableDirective, DataTablesModule } from "angular-datatables";
import { ToastrService } from "ngx-toastr";

import { CommonModule } from "@angular/common";
import { Config } from "datatables.net";

import * as moment from "moment-timezone";
import { AvatarModule } from "ngx-avatars";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { FileUploadModule } from "primeng/fileupload";

import { NgbModal, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { PaginatorModule } from "primeng/paginator";
import { OutPostModalService } from "src/app/shared/header/outpost-list-modal/out-post-modal.service";
import { COOKIE_PREFIX, IMG_PREFIX } from "src/environments/environment";
import swal from "sweetalert2";
import {
  API_URLS,
  AVATAR_BG_COLOR,
  AVATAR_FG_COLOR,
  DATEFORMATE,
  FILE_PATH_CAGE,
  FILE_PATH_PET,
  MAX_FILE_SIZE,
  MOMENT_FORMAT_START_DATE,
  P_CALENDAR_DATE_FORMAT,
  PAGINATION,
  SELECT_SEX,
} from "../../../config/app.constants";
import { OutpostListModalComponent } from "../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
import { ValidationService } from "../../../shared/services/validation.service";
import { SpinnerComponent2 } from "../../../shared/spinners/spinner2.component";
import { Utils } from "../../../shared/utils";
import { ContactUsComponent } from "../contact-us/contact-us.component";
import { TestimonialsComponent } from "../testimonials/testimonials.component";
declare var $: any;

@Component({
  selector: "app-pet-details",
  templateUrl: "./pet-details.component.html",
  styleUrls: ["./pet-details.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    SpinnerComponent2,
    NgxTrimDirectiveModule,
    CalendarModule,
    SharedModule,
    DataTablesModule,
    TestimonialsComponent,
    ContactUsComponent,
    OutpostListModalComponent,
    PaginatorModule,
    NgbTooltipModule,
  ],
})
export class PetDetailsComponent implements OnInit {
  @ViewChild("checkout") checkout: any;
  paginateForBoarding: any = {
    per_page: 10,
    current_page: "",
    total: "",
    length: 10,
  };
  paginateForPan: any = {
    per_page: 5,
    current_page: "",
    total: "",
    length: 5,
  };

  // for data table
  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;
  dtOptionsBoarding: Config = {};
  dtOptionsSubscription: Config = {};

  displayHealthMap;
  spinnerVariable: boolean;
  perPage = PAGINATION;
  filter: string;

  // general
  cageModal = false;
  select_sex = SELECT_SEX;
  submitted: boolean = false;
  currentPetId: string = "";
  petInformation;
  activeSubscription;
  format = DATEFORMATE;
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  cageList;
  filePathCage = FILE_PATH_CAGE;
  filePathPet = FILE_PATH_PET;
  boardingList: any = [];
  subscriptionList: any = [];

  // for edit from
  petDetails: FormGroup;
  name = new FormControl("", [Validators.required]);
  sex = new FormControl("", [Validators.required]);
  color = new FormControl("", [Validators.required]);
  age = new FormControl("", [
    Validators.required,
    Validators.pattern("^[0-9]+(.?[0-9]+)*$"),
  ]);
  weight = new FormControl("", [
    Validators.required,
    Validators.pattern("^[0-9]+(.?[0-9]+)*$"),
  ]);
  breed = new FormControl("", [Validators.required]);
  microchip = new FormControl("", {});
  description = new FormControl("", {});

  // date picker variables
  inwardDate: Date;
  selectedDateArray = [];
  outwardDate: Date;
  minInWardDate: Date;
  maxDate: Date;

  invalidDates: Array<Date>;
  checkInDate: any;
  checkoutDate: any;
  CheckAvailability = false;
  isPetAvailable: boolean = false;
  totalDays: any;
  selectedPetNumber: number = 1;

  // image variables
  coverImage = [];
  upload_pet_image = API_URLS.UPLOAD_PLAN_IMAGE;
  tokenHeader: HttpHeaders = new HttpHeaders().set(
    "Authorization",
    "Bearer " + localStorage.getItem(`${COOKIE_PREFIX}_token`)
  );
  maxFileSize = MAX_FILE_SIZE;
  selectedOutpostId;
  title;
  apiParams = {};
  showOutpostModal: boolean = false;
  selectedOutpost: any = "";
  selectedCageData;
  selectedType: any;
  currentBoardService;
  avatar_fg_color = AVATAR_FG_COLOR;
  avatar_bg_color = AVATAR_BG_COLOR;
  constructor(
    private http: HttpinterceptorService,
    private formBuilder: FormBuilder,
    private toasterService: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    public modalService: NgbModal,
    private validationService: ValidationService,
    private outpostModalService: OutPostModalService
  ) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;

    effect(() => {
      const el = this.outpostModalService.currentBoardService();
      if (el) {
        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
      }
    });
  }

  ngOnInit() {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    this.displayHealthMap = localStorage.getItem("show_health_map");
    this.initPetDetail();
    this.route.params.subscribe((params) => {
      this.currentPetId = params["id"];
      this.getBoarding();
      this.getSubscription();
      this.getPetDetail();
    });
    if (sessionStorage.getItem("bookingPet")) {
      sessionStorage.removeItem("bookingPet");
    }

    // this.currentBoardService =
    //   this.outpostModalService.currentBoardService.subscribe((el: any) => {
    //     if (el) {
    //       if (localStorage.getItem("selectedOutpostId")) {
    //         this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //       }
    //     }
    //   });
  }

  getPetDetail() {
    this.http
      .post(
        API_URLS.PET_DETAILS + this.currentPetId,
        { active_subscription: 1 },
        false
      )
      .subscribe(
        (res) => {
          if (res.code == 200 && res.type === "success") {
            if (res.data) {
              this.isPetAvailable = true;
              this.petInformation = res.data;
              this.title = this.petInformation?.active_subscription
                ?.is_new_subscription
                ? "No. of Extra Services"
                : "No. of Add-ons";
              this.activeSubscription = this.petInformation.active_subscription;
              if (this.activeSubscription) {
                this.activeSubscription["services"] = this.activeSubscription
                  .is_new_subscription
                  ? this.activeSubscription.subscribed_services_with_group_by
                  : this.activeSubscription.subscription_features;

                this.activeSubscription["extra_services"] = this
                  .activeSubscription.is_new_subscription
                  ? this.activeSubscription.subscribed_extra_services
                  : this.activeSubscription.subscribed_addons;
              }
            }
          }
        },
        (error) => {
          this.router.navigate(["/"]);
        }
      );
  }

  initPetDetail() {
    this.petDetails = this.formBuilder.group({
      name: this.name,
      age: this.age,
      color: this.color,
      sex: this.sex,
      weight: this.weight,
      breed: this.breed,
      microchip: this.microchip,
      description: this.description,
    });
  }

  getBoarding() {
    let apiParams = JSON.parse(JSON.stringify(this.paginateForBoarding));
    apiParams["search_key"] = this.filter;
    apiParams["pet_id"] = this.currentPetId;
    this.http.post(API_URLS.GET_BOOKINGS, apiParams, false).subscribe((res) => {
      this.boardingList = res.data.data;
      this.paginateForBoarding.per_page = res.data.per_page;
      this.paginateForBoarding.current_page = res.data.current_page;
      this.paginateForBoarding.total = res.data.total;
    });
  }

  getSubscription() {
    let apiParams = JSON.parse(JSON.stringify(this.paginateForBoarding));
    apiParams["search_key"] = this.filter;
    apiParams["pet_id"] = this.currentPetId;
    apiParams["status"] = "completed,payment_fail";
    this.http
      .post(API_URLS.GET_SUBSCRIPTION, apiParams, false)
      .subscribe((res) => {
        this.subscriptionList = res.data.data;
        this.paginateForPan.per_page = res.data.per_page;
        this.paginateForPan.current_page = res.data.current_page;
        this.paginateForPan.total = res.data.total;
      });
  }

  openPetEditModal() {
    this.submitted = false;
    this.petDetails.patchValue(this.petInformation);
    if (this.petInformation.avatar) {
      this.coverImage = [
        {
          file: this.petInformation.avatar,
          path: this.filePathPet + this.petInformation.id,
        },
      ];
    }
    $(".edit-pet-modal").modal("toggle");
    Utils.disableBodyScroll();
  }

  toastMessage(type, message) {
    this.toasterService[type](message);
  }

  selectInwardDate() {
    if (this.inwardDate) {
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[0] + "/" + expectedOutward[1] + "/" + expectedOutward[2]
      );
      this.invalidDates = [this.inwardDate];
      this.checkout.showOverlay(
        this.checkout.inputfieldViewChild.nativeElement
      );
    }
  }

  selectOutwardDate() {
    if (this.inwardDate) {
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      const outwardDate = Utils.getDateFormat(this.outwardDate);
      const checkInDate =
        inwardDate[0] + "/" + inwardDate[1] + "/" + inwardDate[2];
      const checkoutDate =
        outwardDate[0] + "/" + outwardDate[1] + "/" + outwardDate[2];
      if (checkInDate == checkoutDate) {
        this.outwardDate = null;
        this.selectInwardDate();
        return false;
      } else {
        const checkinDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
        const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
        const totalDays = checkoutDiff.diff(checkinDiff, "days");
        this.selectedDateArray = [];
        const date = Utils.getDateFormat(this.inwardDate);
        this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
        for (let i = 1; i <= totalDays; i++) {
          const expectedOutwardDate = this.addDays(this.inwardDate, i);
          const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
          this.selectedDateArray.push(
            expectedOutward[0] +
              "/" +
              expectedOutward[1] +
              "/" +
              expectedOutward[2]
          );
        }
      }
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }

  getSelectedDays(date) {
    if (!this.outwardDate) {
      if (this.inwardDate) {
        const format = date.day + "/" + (date.month + 1) + "/" + date.year;
        return this.selectedDateArray.includes(format);
      }
    } else {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  checkCageAvailability() {
    if (this.inwardDate) {
      if (!this.outwardDate) {
        this.toastMessage("error", "Please select Check-Out date");
        return false;
      }
      let inward_date;
      let outward_date;
      if (this.inwardDate && this.outwardDate) {
        const inwardDate = Utils.getDateFormat(this.inwardDate);
        const outwardDate = Utils.getDateFormat(this.outwardDate);
        inward_date = inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2];
        outward_date =
          outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2];
      }
      this.http
        .post(
          API_URLS.GET_CAGE_TYPE,
          {
            pet_type_id: this.petInformation.pet_type_id,
            no_of_pet: this.selectedPetNumber,
            inward_date: inward_date,
            outward_date: outward_date,
            out_post_id: this.selectedOutpostId,
          },
          false
        )
        .subscribe(
          (res) => {
            this.cageModal = true;
            $("#cageSelectionModal").modal("toggle");
            Utils.disableBodyScroll();
            if (res.code == 200 && res.type === "success") {
              if (res.data && res.data.length > 0) {
                this.cageList = res.data;
                this.setCages();
              }
            }
          },
          (error) => {
            this.router.navigate(["/"]);
          }
        );
    } else {
      this.toastMessage("error", "Please select Check-In date");
      return false;
    }
  }

  setCages() {
    for (const index in this.cageList) {
      if (Object.prototype.hasOwnProperty.call(this.cageList, index)) {
        if (this.cageList[index].size) {
          const data = this.cageList[index].size.split(",");
          this.cageList[index]["width"] = data[0];
          this.cageList[index]["height"] = data[1];
          this.cageList[index]["length"] = data[2];
          this.cageList[index]["unit"] = data[3];

          if (
            this.cageList[index].outpost_images &&
            this.cageList[index].outpost_images.cover_images
          ) {
            this.cageList[index]["default_cover_image"] =
              this.cageList[index].outpost_images.cover_images;
          } else {
            this.cageList[index]["default_cover_image"] =
              this.cageList[index].cover_image;
          }
        }
        let price;
        if (this.cageList[index].amount % 1 !== 0) {
          price = this.cageList[index].amount.toString().split(".");
          this.cageList[index]["doller"] = price[0];
          this.cageList[index]["cent"] = price[1];
        } else {
          this.cageList[index]["doller"] = this.cageList[index].amount;
          this.cageList[index]["cent"] = "00";
        }
      }
    }
  }

  onCoverUploadAuto(event) {
    const coverImage = event.originalEvent.body.data;
    this.coverImage = [];
    if (coverImage && coverImage[0]) {
      this.coverImage.push({ file: coverImage[0], path: `${IMG_PREFIX}/tmp` });
    } else {
      this.toasterService.error(
        `Given file is not an image. Only jpeg,png,jpg,gif,svg formate are allowed`
      );
    }
    this.spinnerVariable = false;
  }

  fileUploadProgress() {
    this.spinnerVariable = true;
  }

  fileUploadError() {
    this.spinnerVariable = false;
  }

  removeCover(coverImage, imageName) {
    for (const index in coverImage) {
      if (Object.prototype.hasOwnProperty.call(coverImage, index)) {
        if (coverImage[index].file == imageName) {
          coverImage.splice(index, 1);
        }
      }
    }
    this.coverImage = coverImage;
  }

  savePetDetails() {
    this.submitted = true;

    if (this.petDetails.valid) {
      if (this.coverImage.length > 0) {
        if (this.petInformation?.avatar !== this.coverImage[0]?.file) {
          this.petDetails.value["avatar_tmp"] = this.coverImage[0].file;
        } else {
          this.petDetails.value["avatar_tmp"] = "";
        }
      } else {
        this.petDetails.value["avatar"] = "";
      }
      this.http
        .post(
          API_URLS.PET_DETAILS_UPDATE + this.currentPetId,
          this.petDetails.value,
          true
        )
        .subscribe(
          (res) => {
            if (res.code == "200" && res.type === "success") {
              this.submitted = false;
              $(".edit-pet-modal").modal("toggle");
              this.closeModal();
              this.coverImage = [];
              this.petDetails.reset();
              this.ngOnInit();
            }
          },
          (error) => {
            this.submitted = false;
            return false;
          }
        );
    } else {
      this.toastMessage("error", "Please enter valid pet details");
      return false;
    }
  }

  unsubscribe(addonDetails) {
    let message, url;
    if (this.activeSubscription.is_new_subscription) {
      message = "You want to unsubscribe Extra Service?";
      url = API_URLS.STOP_EXTRA_SERVICES_SERVICES;
    } else {
      message = "You want to unsubscribe addon?";
      url = API_URLS.STOP_ADDON_SERVICES;
    }
    swal
      .fire({
        title: message,
        icon: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      })
      .then((isConfirm) => {
        if (isConfirm.value) {
          this.http.post(url + addonDetails.id, {}, true).subscribe((res) => {
            this.ngOnInit();
          });
        }
      });
  }

  validateImageFile($event: any, fubauto): void {
    this.validationService.validateFileUpload($event, fubauto);
  }

  setSession() {
    if (this.inwardDate) {
      const sessionObject = {
        fromDate: this.inwardDate,
        toDate: this.outwardDate,
        totalPets: this.selectedPetNumber,
      };
      sessionStorage.removeItem("filterRanges");
      sessionStorage.filterRanges = JSON.stringify(sessionObject);

      sessionStorage.setItem("bookingPet", JSON.stringify(this.petInformation));
    }
  }

  bookCage(cage) {
    let petTypeId = this.petInformation.pet_type_slug
      ? this.petInformation.pet_type_slug
      : this.petInformation.pet_type_id;
    if (cage.is_available_for_outpost) {
      $("#cageSelectionModal").modal("toggle");
      this.closeModal();
      this.setSession();
      this.router.navigate(["/cage_booking", petTypeId, cage.slug]);
    }
  }
  goToSubscriptindetail(subscriptionDetail) {
    if (subscriptionDetail.is_new_subscription) {
      this.router.navigate(["/subscription/new/detail", subscriptionDetail.id]);
    } else {
      this.router.navigate(["/subscription/detail", subscriptionDetail.id]);
    }
  }
  onSelect(cageData, type) {
    this.selectedCageData = cageData;
    this.selectedType = type;
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.apiParams = {
      service_id: cageData.id,
      service_type: "boarding",
      type: "",
    };
    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe((response) => {
      if (response) {
        this.selectedOutpost = response.title;
        this.selectedOutpostId = response.id;
        this.getPetDetail();
        this.storeOutpostIdInLocalStorage();
        setTimeout(() => {
          Utils.enableBodyScroll();
        }, 500);
        $("#cageSelectionModal").modal("toggle");
        this.setSession();
        this.router.navigate([
          "/cage_booking",
          this.petInformation.pet_type_id,
          this.selectedCageData.id,
        ]);
      }
    });
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }
  closeModal() {
    Utils.enableBodyScroll();
  }
  paginateApply(event, from) {
    if (from == "boarding") {
      this.paginateForBoarding.per_page = 10;
      this.paginateForBoarding.start = event.page * 10;
      this.paginateForBoarding.length = 10;
      this.paginateForBoarding.draw = 1;
      this.getBoarding();
    } else {
      this.paginateForPan.per_page = 5;
      this.paginateForPan.start = event.page * 5;
      this.paginateForPan.length = 5;
      this.paginateForPan.draw = 1;
      this.getSubscription();
    }
  }
}
